module.exports = "http://cdn.realive.com.ua/src/views/player/documets/msc/images/logo.png";